<template>
  <div>
    <v-card color="#EDF1F3">
      <v-layout align-center justify-start style="padding-inline-start:20px">
        <loading-component :value="loading"/>
          <v-form ref="form"><img
            :src="imageFile ? imageUrl : api.GET_IMAGE(user.profile_image)"
            class="image"
            @click="$refs.image.click()"
          ></img>
          <input
            type="file"
            style="display: none"
            ref="image"
            accept="image/*"
            @change="onFilePicked"
          /></v-form>
        <v-flex xs8>
            <div>
              <div class="headline">{{this.user.first_name }} {{this.user.last_name }}</div>
              <div style="color:#8599A3">{{this.user.username}}</div>
              <div style="color:#8599A3;margin-top:6px">{{ $companyTime(user.created_at, " DD MMM YYYY") }}</div>
            </div>
        </v-flex>
        <v-flex>
      <v-switch
            v-if="this.$store.state.user.roles[0].name == 'Super Admin'"
            v-model="disabledSwitch"
            :label="$t('staffPage.disable')"
            @change="changeDisabledStatus"
            color="blue"
          ></v-switch>  
        </v-flex>
      </v-layout>
    </v-card>
  
    <v-card class="card-info">
   
   
      <v-layout align-start>
        <v-flex xs6 style="height: 100%; margin-inline-start: 100px">
          <v-card-title primary-title>
            <v-flex xs12 style="margin-bottom: 25px"
              ><div class="headline">{{ $t("staffPage.personalInformation") }}</div></v-flex
            >
            <v-flex xs6>
              <v-flex style="margin-bottom: 15px">
                <div>{{ $t("staffPage.firstName") }}</div></v-flex
              >
              <v-flex style="margin-bottom: 15px"><div>{{ $t("staffPage.lastName") }}</div></v-flex>
              <v-flex style="margin-bottom: 15px"><div>{{ $t("staffPage.email") }}</div></v-flex>
              <v-flex style="margin-bottom: 15px"><div>{{ $t("staffPage.gender") }}</div></v-flex>
              <v-flex style="margin-bottom: 15px"><div>{{ $t("staffPage.dateOfBirth") }}</div></v-flex>
              <v-flex style="margin-bottom: 15px"
                ><div>{{ $t("staffPage.phoneNumber") }}</div></v-flex
              >
              <v-flex style="margin-bottom: 15px"
                ><div>{{ $t("staffPage.status") }}</div></v-flex
              ></v-flex
            >

            <v-flex xs6>
              <v-flex style="margin-bottom: 15px">
                <b>{{ this.user.first_name || $t("staffPage.noDataAvailable") }}</b></v-flex
              >
              <v-flex style="margin-bottom: 15px"
                ><b>{{ this.user.last_name || $t("staffPage.noDataAvailable") }}</b></v-flex
              ><v-flex style="margin-bottom: 15px"
                ><b>{{ this.user.username || $t("staffPage.noDataAvailable") }}</b></v-flex
              ><v-flex style="margin-bottom: 15px"
                ><b v-if="this.user.gender == true">{{ $t("staffPage.genderMale") }}</b
                ><b v-if="this.user.gender == false">{{ $t("staffPage.genderFemale") }}</b></v-flex
              ><v-flex style="margin-bottom: 15px"
                ><b>{{ this.user.birthday || $t("staffPage.noDataAvailable")}}</b></v-flex
              ><v-flex style="margin-bottom: 15px"><b >{{this.user.phone_number}}</b></v-flex
              ><v-flex style="margin-bottom: 15px"
                ><b v-if="!this.user.deleted_at">{{ $t("staffPage.active") }}</b
                ><b v-if="this.user.deleted_at">{{ $t("staffPage.inactive") }}</b></v-flex
              ></v-flex
            >
          </v-card-title>
        </v-flex>
        <v-flex xs6 style="height: 100%">
          <v-card-title primary-title>
            <v-flex xs12 style="margin-bottom: 25px"
              ><div class="headline">{{ $t("staffPage.documents") }}</div></v-flex
            >
            <v-flex xs4>
              <v-flex style="margin-bottom: 15px">
                <div>{{ $t("staffPage.workingContract") }}</div></v-flex
              >
              <v-flex style="margin-bottom: 15px"
                ><div>{{ $t("staffPage.iban") }}</div></v-flex
              >
              <v-flex style="margin-bottom: 15px"
                ><div>{{ $t("staffPage.paySlip") }}</div></v-flex
              >
              <v-flex style="margin-bottom: 15px"
                ><div>{{ $t("staffPage.planning") }}</div></v-flex
              >
              
            </v-flex>

            <v-flex xs4>
              <v-flex style="margin-bottom: 15px">
                <b
                  ><a
                    href="#"
                    @click="openImage(user.ministerial_authorization)"
                    >{{ $t("staffPage.open") }}</a
                  ></b
                ></v-flex
              >
              <v-flex style="margin-bottom: 15px"
                ><b
                  ><a href="#" @click="openImage(user.livret_professionnel)"
                    >{{ $t("staffPage.open") }}</a
                  ></b
                ></v-flex
              ><v-flex style="margin-bottom: 15px"
                ><b
                  ><a href="#" @click="openImage(user.medical_certificate)"
                    >{{ $t("staffPage.open") }}</a
                  ></b
                ></v-flex
              ><v-flex style="margin-bottom: 15px"
                ><b
                  ><a href="#" @click="openImage(user.electric_radio_license)"
                    >{{ $t("staffPage.open") }}</a
                  ></b
                ></v-flex
              ></v-flex
            >
           
          </v-card-title>  
        </v-flex>
      </v-layout>
    </v-card>


  </div>
</template>

<script>

import DataTable from "@/components/monaco/DataTable";
import { companyNow } from "@/util/companyTime";
import LoadingComponent from "@/components/LoadingComponent";

export default {
  name: "StaffProfile",
  title() {
    return this.$t("staffPage.profilePageTitle");
  },
  components:{
    LoadingComponent,
    DataTable,
  },

  data() {
    return {
      user: "",
      disabledSwitch:false,
      imageName: "",
      imageUrl: "",
      imageFile: "",
      loading:false,
    };
  },
  mounted() {
    this.axios.get(`user/${this.$route.params.id}`).then(({ data }) => {
      // data.data.average_rating = this.round(data.data.average_rating, 1);
      this.user = data.data;
      this.disabledSwitch = data.data.disabled_at != null;
      // this.languages=data.data.languages;
      console.log(this.user);

      this.loading = false;
    });

  },

  methods: {
    changeDisabledStatus(value) {
      let disabled = value ? 1 : 0;
      let id = this.user.id;
      this.loading = true;
      this.axios
        .put('user/'+id+'/change_disabled_at_value', { disabled })
        .then((res) => {
          this.loading = false;
          let toastMessage = value
            ? this.$t("staffPage.accountDisabled")
            : this.$t("staffPage.accountEnabled");
          window.getApp.$emit("SHOW_TOAST", toastMessage, "green");
        })
        .catch((err) => {
          this.loading = false;
          console.log("error");
        });
    },

    openImage(value) {
      console.log(value);
      // if (id === 1)
      
      window.open(
        this.api.GET_IMAGE(value),
        "_blank"
      );

    },

    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },

    save() {
      if (this.$refs.form.validate()) {
        this.loading=false;
        const updatedData = [];
        if (this.imageFile)
          updatedData.push({ ["captain[profile_image]"]: this.imageFile });
        if (updatedData.length > 0) {
          this.loading = true;
          const formData = new FormData();
          formData.append("_method", "PUT");
          for (const field of updatedData) {
            const key = Object.keys(field)[0];
            formData.append(key, field[key]);
          }
          this.axios
            .post(this.api.ACTIONS.CAPTAINS + "/" + this.captain.id, formData)
            .then(({ data }) => {
              this.imageName = "";
              this.imageFile = "";
              this.imageUrl = "";
              this.captain = data.data;
              this.loading = false;
              window.getApp.$emit("SHOW_TOAST", this.$t("staffPage.saved"));
            });
        }
      } else {
        window.getApp.$emit("SHOW_TOAST", this.$t("staffPage.pleaseCheckAllFields"), "red");
      }
    },
  },
  computed: {
    titles() {
      return {
        id: "#",
        start_datetime: this.$t("staffPage.colDate"),
        pick_up_location_name: this.$t("staffPage.colPickUpLocation"),
        drop_off_location_name: this.$t("staffPage.colDropOffLocation"),
        passenger_name: this.$t("staffPage.colPassenger"),
        meter_price: this.$t("staffPage.colPrice"),
        captain_rating: this.$t("staffPage.colRating"),
        from_datetime: this.$t("staffPage.colDatetime"),
        status: this.$t("staffPage.colStatus"),
        station_id: this.$t("staffPage.colStationId")
      };
    },

    rideSearchParams() {
      const params = new URLSearchParams();
      params.append('captain_id', this.captain.id);
      params.append('filter', 'ALL');
      return params;
    },
    logSearchParams(){
      const params = new URLSearchParams();
      params.append('captain_id', this.captain.id);
      return params;
    },
    today() {
      return companyNow().format("YYYY-MM-DD");
    },
    actionsExtraMain() {
      return {
        prices: {
          title: this.$t("staffPage.captainProfile"),
          icon: "account_circle",
          action: (item) =>
            this.$router.push({
              name: "CaptainProfile",
              params: { id: item.id },
            }),
        },
      };
    },
  },
  
  formatter() {
    return {
      // created_at(value) {
      //   return moment(value).format(" DD MMM YYYY");
      // },

      active(val) {
        //language=HTML
        return `
                      <i class="v-icon fa ${
                        val ? "fa-check" : "fa-close"
                      }"></i>
                      `;
      },
    };
  },
};
</script>

<style scoped>




.car {
    color: #7E939C;
}
.image{
  border-radius: 100%;
  height:100px;
  width:100px;
  margin-inline-end:17px;
  margin-top:10px
}
.image:hover {

    background-color:black;
    opacity:0.5;
    border-radius:100%;
    cursor: pointer;
}
.card-info{
  height: 100%;
  position: absolute;
  width: 100%;
}
</style>